import { FeedbackSection } from './styled';
import { Text, Button, useTheme } from '@simplywallst/ui-core';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';

const Feedback = () => {
  const theme = useTheme();
  const makeTypeformPopup = useTypeformDrawer('CQ5uBt42');

  return (
    <FeedbackSection
      templateColumns="auto auto auto"
      gap={`${theme.x1spacePx}px`}
      justifyContent="start"
      alignItems="center"
    >
      <InformationSolid fill={theme.color.whiteRGBA(0.5)} />
      <Text typography="xSmall" color="whiteRGBA" opacity={0.8}>
        Narratives are currently in beta
      </Text>
      <Text typography="xSmall">
        <Button
          marginLeft
          styleType="strongLink"
          display="inline"
          onClick={makeTypeformPopup}
        >
          Give Feedback
        </Button>
      </Text>
    </FeedbackSection>
  );
};

export default Feedback;
